export default "__VITE_ASSET__56dafa5d__"